import React from "react";
import { CustomSearchTextField } from "../../../../../Components/CustomMuiComponents";
import { InputAdornment } from "@mui/material";
import { Search } from "@mui/icons-material";

export default function FilterUnidadN({ filter, setFilter }) {
  return (
    <CustomSearchTextField
      placeholder="Buscar"
      size="small"
      variant="outlined"
      fullWidth
      value={filter}
      onChange={(e) => setFilter(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
